<app-auth-layout
  variant="split"
  [headline]="asideKey + '.headline' | transloco"
  [tagline]="asideKey + '.tagline' | transloco"
  [languages]="languageOptions"
  [currentLanguage]="language"
  (languageChange)="selectLanguage($event)"
>
  <div class="content">
    <div class="overlay" *ngIf="isLoading">
      <p-progressSpinner strokeWidth="4"></p-progressSpinner>
    </div>

    <div [style.display]="isDivCreate">
      <h2 class="auth-title">{{ 'user.activateAccount.title1' | transloco }} {{ 'user.activateAccount.title2' | transloco }}</h2>
      <p class="auth-subtitle">
        {{ 'user.activateAccount.body1' | transloco }}<strong>{{ email }}</strong>{{ 'user.activateAccount.body2' | transloco }}
      </p>
      <p class="auth-subtitle">{{ 'user.activateAccount.linkMsg' | transloco }}</p>

      <div class="alert" role="alert" *ngFor="let message of messagesCode">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="7.5" x2="12" y2="13" />
          <circle cx="12" cy="16.5" r="0.6" />
        </svg>
        <span>{{ message.summary }}</span>
      </div>

      <div class="auth-actions">
        <button type="button" class="chamfer outline" [disabled]="isButtonDisabled" (click)="sendEmailAgain()">
          {{ 'user.activateAccount.resendEmail' | transloco }}<ng-container *ngIf="isButtonDisabled"> ({{ countdown }}s)</ng-container>
        </button>
      </div>

      <p class="restart">
        {{ 'user.activateAccount.body3' | transloco }}
        {{ 'user.activateAccount.body5' | transloco }}
        <button type="button" class="text-link" (click)="expired()">{{ 'user.activateAccount.body6' | transloco }}</button>
      </p>
    </div>

    <div [style.display]="isDivActivated">
      <div class="auth-status-tile is-success" aria-hidden="true">
        <svg viewBox="0 0 24 24"><polyline points="5,12.5 10,17.5 19,7.5" /></svg>
      </div>
      <h2 class="auth-title">{{ (alreadyConfirmed ? 'user.activateAccount.alreadyActivated' : 'user.activateAccount.title3') | transloco }}</h2>
      <p class="auth-subtitle">
        {{ 'user.activateAccount.body4' | transloco }}
        <button type="button" class="text-link" id="redirect" (click)="redirect()">{{ 'user.activateAccount.body6' | transloco }}</button>
      </p>
      <div class="auth-actions">
        <button type="button" class="chamfer" (click)="redirect()">{{ 'user.activateAccount.goToLogin' | transloco }}</button>
      </div>
    </div>

    <div [style.display]="isDivExpired">
      <div class="auth-status-tile is-alert" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <circle cx="11" cy="12" r="8.5" />
          <polyline points="11,7 11,12 14,14" />
          <line x1="20" y1="3.5" x2="20" y2="8" />
          <circle cx="20" cy="11" r="0.6" />
        </svg>
      </div>
      <h2 class="auth-title">{{ 'user.activateAccount.title4' | transloco }}</h2>
      <p class="auth-subtitle">
        {{ 'user.activateAccount.body5' | transloco }}
        <button type="button" class="text-link" id="expired" (click)="expired()">{{ 'user.activateAccount.body6' | transloco }}</button>
      </p>
      <div class="auth-actions">
        <button type="button" class="chamfer" (click)="expired()">{{ 'user.createAccount.btnCreateAccount' | transloco }}</button>
        <button type="button" class="chamfer outline" (click)="redirect()">{{ 'user.createAccount.btnBack' | transloco }}</button>
      </div>
    </div>
  </div>
</app-auth-layout>
